<div [ngClass]="{'b-b b-col-42 p-l-3 p-r-3 p-t-6 p-b-5' : expandableIcon === 'plus' && addBorder}">
    <div class="flex flex-justify-between cursor-pointer col-1"
         [ngClass]="{'p-b-3 p-t p-t-1-s' : expandableIcon === 'chevron'}"
         [zippyToggle]="zippyId">

        <!-- title -->
        <div class="flex-grow w-12 flex flex-middle flex-justify-between pos-relative">
            @if(!expandableTitle) {
            <ng-container *ngTemplateOutlet="expandableTitleTpl"></ng-container>
            } @else {
            <label [zippyName]="zippyId"
                   [zippyClass]="expandableIcon === 'chevron' ? 'col-12' : ''">{{expandableTitle}}</label>
            }
        </div>

        <!-- icon -->
        @if(expandableIcon === 'chevron') {
        <i class="icon-chevron expandable-icon flex flex-middle fs-9"
           [zippyClass]="'rotate-90 col-12'"
           [zippyName]="zippyId"></i>
        }

        @if(expandableIcon === 'plus') {
        <i class="icon-plus fs-7"
           [zippyClass]="'icon-minus !icon-plus'"
           [zippyName]="zippyId"></i>
        }
    </div>

    <!-- body -->
    <div [zippyHideUp]="zippyId"
         [zippyState]="openAtStart">
        @if(expandableTitle) {
        <ng-container *ngTemplateOutlet="expandableContentTpl"></ng-container>
        } @else {
        <ng-container *ngTemplateOutlet="expandableBodyTpl"></ng-container>
        }
    </div>
</div>

<ng-template #expandableTitleTpl>
    <ng-content select="[expandableTitle]"></ng-content>
</ng-template>
<ng-template #expandableBodyTpl>
    <ng-content select="[expandableBody]"></ng-content>
</ng-template>
<ng-template #expandableContentTpl>
    <ng-content></ng-content>
</ng-template>